"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = void 0;

var _preact = require("preact");

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _excluded = ["title", "onClose"];

var ModalHeader = function ModalHeader(_ref) {
  var _rest$elementName;

  var title = _ref.title,
      onClose = _ref.onClose,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)("header", {
    className: "control-modal-header"
  }, (0, _preact.h)("div", {
    className: "control-modal-header-title",
    id: "modal-header-title"
  }, title), rest.subTitle ? (0, _preact.h)("div", {
    className: "control-modal-header-subtitle"
  }, rest.subTitle) : null, (0, _preact.h)("button", {
    className: "control-header-close",
    tabIndex: 2,
    onClick: function onClick() {
      return onClose();
    },
    "data-track-type": "click",
    "data-element-name": (_rest$elementName = rest.elementName) !== null && _rest$elementName !== void 0 ? _rest$elementName : ''
  }, (0, _preact.h)(_Close.default, null)));
};

exports.ModalHeader = ModalHeader;